import {Validation, type ValidationConfig, type ValidationResponse, WarningLevel} from "./validations";
import type {InputType} from "../commons";
import type {FormInputElement} from "../components/formInputElement";

export type PermittedValuesConfig = ValidationConfig & {
    id: "permittedValues";
    permittedValues: string;
};

export class PermittedValues extends Validation {

    private values: string[];

    private constructor(messageText: string, onlyWarning: WarningLevel, permittedValues: string) {
        super(messageText, onlyWarning);
        this.values = permittedValues.split(",")
            .map(value => value.trim());
    }

    public static from(config: PermittedValuesConfig): PermittedValues {
        return new PermittedValues(config.message, config.warningLevel, config.permittedValues);
    }

    protected valid(value: unknown): boolean {
        return typeof value === "string"
            && (value === "" || this.values.includes(value));
    }

    public accept<T extends InputType>(inputElement: FormInputElement<T>, value?: T): void {
        const validationResponse: ValidationResponse = this.checkValidity(value);

        if (!validationResponse.valid) {
            inputElement.addMessage({warningLevel: validationResponse.warningLevel, message: this.errorText});
        }
    }

}